<template>
  <div>
    <div class="details-component">
      <div class="details-component__header">
        <h1>{{ $t('conference.registered_vehicles') }}</h1>
      </div>

      <div class="keyword-filter">
        <label class="keyword-filter__wrapper">
          <input type="text"
            ref="search"
            class="keyword-filter__input"
            placeholder=""
            autocomplete="off"
            v-model.trim="parkingsFilterText"
            name="keywordFilter"
            @keydown.enter.prevent.stop=""
            @keyup.enter.prevent.stop="" />
        </label>
      </div>
      <div class="parking" v-for="parking in filteredParkings()" v-bind:key="parking.id">
        <div class="remove">
          <a v-if="isLandlord()" v-on:click="showDeletingConfirmation(parking.id)" class="link link--orange">{{ $t('common.delete') }}&nbsp;<i class="icon icon--cross"></i>
          </a>
        </div>
        <div class="period">
          {{ parking.vehicleReg }}
          <span class="item__subtitle register-time">{{ parking.startTime}}</span>
        </div>
      </div>
    </div>
    <ConfirmationModal v-if="showConfirmationModal" @cancel="cancelConferenceParkingDelete" @confirmed="deleteConferenceParking">
      <h1 slot="header">{{ $t('common.deleting') }}</h1>
      <p slot="body">{{ $t('conference.confirm_parking_delete') }}</p>
    </ConfirmationModal>
    <WarningModal v-if="showWarningModal" @close="closeWarningModal">
      <h1 slot="header">{{ $t('conference.parking_delete_error_header') }}</h1>
      <p slot="body">{{ $t('conference.parking_delete_error_body') }}</p>
    </WarningModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ConfirmationModal from 'common/ConfirmationModal';
import WarningModal from 'common/WarningModal';
import * as mTypes from 'store/mutation-types';

export default {
  components: {
    ConfirmationModal,
    WarningModal,
  },
  computed: mapGetters({
    conferenceParkings: 'parkings/parkings/parkings',
    user: 'user/user/user',
    parkingsError: 'parkings/parkings/error',
    error: 'parkings/parking/error',
  }),
  watch: {
    $route: 'fetchConferenceParkings',
  },
  route: {
    canReuse: true,
  },
  created() {
    if (this.$route.params.id) {
      this.fetchConferenceParkings();
    }
  },
  methods: {
    showDeletingConfirmation(id) {
      this.deleteParkingId = id;
      this.showConfirmationModal = true;
    },
    cancelConferenceParkingDelete() {
      this.deleteParkingId = null;
      this.showConfirmationModal = false;
    },
    deleteConferenceParking() {
      this.showConfirmationModal = false;
      this.$store.dispatch('parkings/parking/deleteConference', { id: this.deleteParkingId, user: this.user, productId: this.$route.params.id }).then(() => {
        if (!this.error) {
          this.$store.commit(`parkings/parkings/${mTypes.REMOVE_DATA}`, this.deleteParkingId);
        } else {
          this.showWarningModal = true;
        }
        this.deleteParkingId = null;
      });
    },
    closeWarningModal() {
      this.showWarningModal = false;
      this.$store.commit(`parkings/parking/${mTypes.DATA_ERROR}`, null);
    },
    fetchConferenceParkings() {
      if (this.$route.params.id && this.user.data) {
        this.$store.dispatch('parkings/parkings/fetchConference', { id: this.$route.params.id, user: this.user });
      }
    },
    filteredParkings() {
      return this.conferenceParkings.filter(this.parkingsFilter);
    },
    parkingsFilter(parking) {
      return (!this.parkingsFilterText || this.parkingsFilterText === '' || parking.vehicleReg.includes(this.parkingsFilterText.toUpperCase()));
    },
  },
  data() {
    return {
      deleteParkingId: null,
      showConfirmationModal: false,
      showWarningModal: false,
      parkingsFilterText: '',
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';
@import '~styles/_mixins.scss';
.parking {border: 1px solid #ccc; padding: 10px; margin: 10px; }
.add {float: right;}
.edit {float: right; margin-left: 10px; cursor: pointer; color: 6688dd;}
.remove {float: right; margin-left: 10px; cursor: pointer; color: 6688dd;}
.register-time { margin-left: 20px; font-size: 12px; }

.keyword-filter {
  display: inline-block;
  max-width: 470px;
  width: calc(100% - 116.5px);
  background-color: var(--white);
  position: relative;
  transition: all 225ms ease-in-out;
  @include shadow(1);

  @media screen and (max-width: 759px) {
    width: 100%;
    max-width: none;
  }

  @media screen and (max-width: 715px) {
    flex: 1;
    display: flex;
  }

  &:focus,
  &:hover,
  &_active {
    transition: all 225ms ease-in-out;
  }

  &.inline-search {
    @include shadow(2);
    background-color: var(--white);
  }

  &_active,
  &.inline-search {

    .keyword-filter__wrapper {
      border-bottom: 1px solid var(--grey-five);
      margin-bottom: 0;
    }
  }

  &__wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 10px 0 10px;
    margin-bottom: 1px;

    @media screen and (max-width: 715px) {
      padding: 0 20px 0 0;
    }

    &:after {
      content: '';
      display: inline-block;
      width: 44px;
      height: 36px;
      background: url('~icons/search.svg') 50% 50% no-repeat;
    }
  }

  &__input {
    font-size: 24px;
    height: 60px;
    border: none;
    width: 100%;
    letter-spacing: 1px;
    margin-right: 20px;

    @media screen and (max-width: 715px) {
      margin: 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/parkings/ConferenceParkings.vue